import { toast } from 'react-toastify'
import i18n from '../locales/i18n'

/**
 * Check input is Array or not
 * @param {Any} arr
 * @return {Boolean}
 */
const isArray = arr => Array.isArray(arr)

/**
 * Check input is Object or not
 * @param {Any} obj
 * @return {Boolean}
 */
const isObject = obj => obj && typeof obj === 'object' && !Array.isArray(obj)

/**
 * Valid input is an Array
 * @param {Any} arr
 * @return {Array}
 */
export const ensureArray = (arr, defaultValue) =>
    isArray(arr) ? arr : isArray(defaultValue) ? defaultValue : []

/**
 * Valid input is an Object
 * @param {Any} arr
 * @return {Object}
 */
export const ensureObject = (obj, defaultValue) =>
    isObject(obj) ? obj : isObject(defaultValue) ? defaultValue : {}

export const convertErrorYup = error => {
    if (error.name !== 'ValidationError') {
        return error
    }

    const errors = {}
    error.inner.forEach(err => {
        if (!errors[err.path]) {
            errors[err.path] = err.message
        }
    })

    return errors
}

export const showMessageSuccess = message => {
    toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
    })
}

export const showMessageError = message => {
    toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
    })
}

export const showMessageWarn = message => {
    toast.warn(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
    })
}

export const errorHandle = ({ message }) => showMessageError(i18n.t(message || 'apiMessage.undefinedError'))

export const shallowFlat = list =>
    ensureArray(list).reduce((rs, current) => [...rs, ...current], [])

/**
 * @param {Any}
 * @return {String}
 */
function toVal(mix) {
    let k
    let y
    let str = ''

    if (typeof mix === 'string' || typeof mix === 'number') {
        str += mix
    } else if (typeof mix === 'object') {
        if (Array.isArray(mix)) {
            for (k = 0; k < mix.length; k++) {
                if (mix[k]) {
                    y = toVal(mix[k])
                    if (y) {
                        str && (str += ' ')
                        str += y
                    }
                }
            }
        } else {
            for (k in mix) {
                if (mix[k]) {
                    str && (str += ' ')
                    str += k
                }
            }
        }
    }

    return str
}

/**
 * @param {Any}
 * @return {String}
 */
export function clsx() {
    let i = 0
    let tmp
    let x
    let str = ''

    while (i < arguments.length) {
        tmp = arguments[i++]
        if (tmp) {
            x = toVal(tmp)
            if (x) {
                str && (str += ' ')
                str += x
            }
        }
    }

    return str
}

export const smoothVerticalScrolling = (
    elm,
    scrollDown,
    scrollPx,
    scrollingRef
) => {
    return new Promise(resolve => {
        if (scrollingRef) return resolve('Scrolling')

        if (elm) {
            const pixelPerStep =
                Math.round(scrollPx / 50) * (scrollDown ? 1 : -1)
            let currentStep = 0
            scrollingRef = setInterval(() => {
                elm.scrollTop -= pixelPerStep
                ++currentStep

                if (currentStep > 50) {
                    scrollingRef = clearInterval(scrollingRef)
                    resolve('Done')
                }
            }, 5)
        }
    })
}

export const isNotEmpty = value => {
    if (value && typeof value === 'object') {
        return !!Object.keys(value).length
    }

    if (value === 0) {
        return true
    }

    return !!value
}

export const getBodyScrollTop = () => document.querySelector('#root')

export const matchFood = (keyword, food) => {
    const { name = '', plu = '' } = food

    return (
        name.toLocaleLowerCase().includes(keyword.toLocaleLowerCase()) ||
        String(plu).includes(keyword)
    )
}

export const getWaitingTimeNextRequestPayment = time =>
    time
        ? Math.max(Math.ceil((time + 30000 - new Date().getTime()) / 1000), 0)
        : 0

export const disableBrowserBack = () => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', function (event) {
        console.log('popstate')
        window.history.pushState(null, document.title, window.location.href)
    })
}

export default {
    ensureArray,
    ensureObject,
    convertErrorYup,
    showMessageSuccess,
    clsx,
    smoothVerticalScrolling,
    isNotEmpty,
    matchFood,
    getWaitingTimeNextRequestPayment,
    disableBrowserBack
}
